import { dataAnalyticsActionTypes } from '../constants/ApiConstants';


const initialState = {
  loading: false,
  dataAnalyticsData: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case dataAnalyticsActionTypes.get_DataAnalytics.REQUEST:
    return {
      ...state,
      loading: true,
      dataAnalyticsData: null,
    };
  case dataAnalyticsActionTypes.get_DataAnalytics.SUCCESS:
    return {
      ...state,
      loading: false,
      dataAnalyticsData: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalytics/reducers/dataAnalyticsReducers.js